export default function Contact() {
  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">お問い合わせ</h2>
          <p className="text-gray-500 text-lg">
            SNSで最新情報をチェックしてください。<br />
            お問い合わせもDMにてお気軽にどうぞ。
          </p>
        </div>

        <div className="flex flex-col items-center gap-8">
          <div className="w-full max-w-xl bg-amber-50 border-2 border-amber-200 rounded-2xl p-10 text-center">
            <div className="w-20 h-20 flex items-center justify-center rounded-full bg-gradient-to-br from-amber-400 to-orange-500 mx-auto mb-6 shadow-md">
              <i className="ri-store-2-line text-white text-4xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-4">店舗導入と個人購入についてはこちら</h3>
            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              以下、SNSおよび電話でお問い合わせください。
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://www.instagram.com/spring_sun_bowl/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-gradient-to-r from-pink-500 to-amber-500 text-white text-base font-medium whitespace-nowrap shadow-sm hover:shadow-md hover:opacity-90 transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
                Instagram
              </a>
              <a
                href="https://x.com/spring_sun_bowl"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-gradient-to-r from-gray-700 to-gray-900 text-white text-base font-medium whitespace-nowrap shadow-sm hover:shadow-md hover:opacity-90 transition-all cursor-pointer"
              >
                <i className="ri-twitter-x-line text-xl"></i>
                X (Twitter)
              </a>
              <a
                href="tel:08035547296"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-gradient-to-r from-emerald-500 to-teal-600 text-white text-base font-medium whitespace-nowrap shadow-sm hover:shadow-md hover:opacity-90 transition-all cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                080-3554-7296
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
